// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"619":"a9d75641","696":"37932338","916":"f8491130"}[chunkId] + ".chunk.css";
};